import { Sch_Queue_Fldr } from '../sch_queue_fldr';
import { CommonEnums } from '../../common.enums';




export class Sch_Queue_FldrsUtil {
    private static instance: Sch_Queue_FldrsUtil;

    static getInstance() {
        if (!Sch_Queue_FldrsUtil.instance) {
            Sch_Queue_FldrsUtil.instance = new Sch_Queue_FldrsUtil();
        }

        return Sch_Queue_FldrsUtil.instance;
    }

    /**
    * Sch_Queue_FldrsUtil is a singleton class, so use Sch_Queue_FldrsUtil.getInstance() method instead of creating new Sch_Queue_FldrsUtil().
    */
    private constructor() {

    }

    getPrimaryKey(sch_Queue_Fldrs: Sch_Queue_Fldr): string {
        return sch_Queue_Fldrs.sch_Queue_Id + '' + sch_Queue_Fldrs.sch_Queue_Id;
    }

    copy(sch_Queue_FldrsTmp: Array<Sch_Queue_Fldr>): Array<Sch_Queue_Fldr> {
        let sch_Queue_Fldrs: Array<Sch_Queue_Fldr> = new Array<Sch_Queue_Fldr>();

        for (let i: number = 0; i < sch_Queue_FldrsTmp.length; i++) {
            let sch_Queue_Fldr: Sch_Queue_Fldr = sch_Queue_FldrsTmp[i] as Sch_Queue_Fldr;
            sch_Queue_Fldrs.push(sch_Queue_Fldr.copy())
        }

        return sch_Queue_Fldrs;
    }

    copyFrom(sch_Queue_Fldrs: Array<Sch_Queue_Fldr>, sch_Queue_FldrsTmp: Array<Sch_Queue_Fldr>): void {
        let sch_Queue_FldrsMap: Map<string, Sch_Queue_Fldr> = new Map<string, Sch_Queue_Fldr>();
        for (let i: number = 0; i < sch_Queue_Fldrs.length; i++) {
            let sch_Queue_Fldr: Sch_Queue_Fldr = sch_Queue_Fldrs[i] as Sch_Queue_Fldr;
            sch_Queue_FldrsMap.set(this.getPrimaryKey(sch_Queue_Fldr), sch_Queue_Fldr);
        }

        sch_Queue_Fldrs.splice(0, sch_Queue_Fldrs.length);

        for (let i: number = 0; i < sch_Queue_FldrsTmp.length; i++) {
            let sch_Queue_FldrTmp: Sch_Queue_Fldr = sch_Queue_FldrsTmp[i] as Sch_Queue_Fldr;

            let sch_Queue_Fldr: Sch_Queue_Fldr = sch_Queue_FldrsMap.get(this.getPrimaryKey(sch_Queue_FldrTmp));
            if (sch_Queue_Fldr) {
                sch_Queue_Fldr.copyFrom(sch_Queue_FldrTmp);
            } else {
                sch_Queue_Fldr = Sch_Queue_Fldr.parse(sch_Queue_FldrTmp);
            }

            sch_Queue_Fldrs.push(sch_Queue_Fldr);
        }
    }

    compare(sch_Queue_Fldrs: Array<Sch_Queue_Fldr>, sch_Queue_FldrsTmp: Array<Sch_Queue_Fldr>) {
        if (sch_Queue_Fldrs.length != sch_Queue_FldrsTmp.length)
            return 'sch_Queue_Fldrs length mismatch.';

        for (let i: number = 0; i < sch_Queue_Fldrs.length; i++) {
            let sch_Queue_Fldr: Sch_Queue_Fldr = sch_Queue_Fldrs[i] as Sch_Queue_Fldr;
            let sch_Queue_FldrTmp: Sch_Queue_Fldr = sch_Queue_FldrsTmp[i] as Sch_Queue_Fldr;

            let diffString: string = sch_Queue_Fldr.compare(sch_Queue_FldrTmp);
            if (diffString != CommonEnums.defaults.STRING_EMPTY) {
                return diffString;
            }
        }

        return '';
    }

    toString(sch_Queue_Fldrs: Array<Sch_Queue_Fldr>) {
        let str: string = '';

        str += 'sch_Queue_Fldr length: ' + sch_Queue_Fldrs.length + ' ';

        for (let i: number = 0; i < sch_Queue_Fldrs.length; i++) {
            let sch_Queue_Fldr: Sch_Queue_Fldr = sch_Queue_Fldrs[i] as Sch_Queue_Fldr;
            str += sch_Queue_Fldr.toString();
        }

        return str;
    }
}